import { motion } from "framer-motion";
import { useTheme } from "@mui/material/styles";

const StatCard = ({ title, icon: Icon, value, color }) => {
  const theme = useTheme(); 

  return (
    <motion.div
      className={`overflow-hidden shadow-lg rounded-xl border ${
        theme.palette.mode === "dark"
          ? "bg-gray-800 border-gray-700"
          : "bg-white border-gray-200"
      }`}
      whileHover={{
        y: -5,
        boxShadow: theme.palette.mode === "dark"
          ? "0 25px 50px -12px rgba(0, 0, 0, 0.5)"
          : "0 25px 50px -12px rgba(0, 0, 0, 0.15)"
      }}
    >
      <div className='px-4 py-5 sm:p-6 flex flex-col'>
        <div className="flex justify-center">
          <Icon size={20} className='mr-1' style={{ color }} />
          {title}
        </div>
        <p className={`mt-1 text-3xl text-center font-semibold ${
          theme.palette.mode === "dark" ? "text-gray-100" : "text-gray-800"
        }`}>
          {value}
        </p>
      </div>
    </motion.div>
  );
};

export default StatCard;
